<template>
  <div id="App">
    <el-form ref="ruleForm" size="small">
      <el-form-item style="text-align: center;">
        <el-button type="primary" @click="onRecord">视频录制</el-button>
      </el-form-item>
    </el-form>

    <el-dialog title="视频录制" width="50%" :visible.sync="dialogVisible" style="z-index: 3000;" :modal="false">

      <video v-loading="loading" controls autoplay playsinline ref="video" style="width: 100%"/>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onCancel">取 消</el-button>
        <el-button :disabled="recorder == null" icon="el-icon-refresh-left" size="small" type="primary" @click="onReset">重新录制</el-button>
        <el-button :disabled="videoStart" icon="el-icon-video-camera-solid" size="small" type="primary" @click="onStart">开始录制</el-button>
        <el-button :disabled="!videoStart" icon="el-icon-remove" size="small" type="primary" @click="onStop">停止录制</el-button>
        <el-button icon="el-icon-remove" size="small" type="primary" @click="onPlay">回放视频</el-button>
        <el-button size="small" type="success" @click="onSave">提交</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

import RecordRTC from 'recordrtc';

export default {
  name: "record-video",
  props: {
    notaryId: {
      type: Number | null | String,
      required: true
    }
  },

  data() {
    return {
      dialogVisible: false,
      video: null,
      videoStart: false,
      recorder: null,
      videoData: null,
      loading: false,
      timer: null,
    }
  },

  destroyed() {
    // 卸载页面销毁timer
    if (this.timer) clearInterval(this.timer)
  },

  methods: {
    captureCamera(callback) {
      navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then((camera) => {
        callback(camera);
      }).catch((error) => {
        this.$message.error("未找到视频设备！");
      });
    },

    onRecord() {
      this.dialogVisible = true;
    },

    onStart() {

      if(!navigator.mediaDevices) {
        this.$notify.warning("不支持视频录制！");
        return;
      }
      this.startRecording();
    },

    onPlay() {
      this.video.src = URL.createObjectURL(this.videoData);
    },

    onReset() {
      this.videoStart = false;
      this.recorder.camera.stop();
      this.recorder.destroy();
      this.recorder = null;
      this.video = null;
      this.videoData = null;

      this.$nextTick(() => {
        this.$message.success("已重新录制！");
        this.startRecording();
      });
    },

    onSave() {
      this.loading = true;

      if (this.videoStart) {
        this.onStop();

        this.timer = setInterval(() => {
          if (this.videoData != null) {
            this.onSave();
            clearInterval(this.timer);
          }
        }, 500);

        return;
      }

      if(this.videoData == null) {
        this.$notify.warning("请先录制视频！");
        return;
      }

      let data = new FormData();
      data.append("file", this.videoData, "视频录制.mp4");

      this.$api.upLoadFile(data).then(video => {

        if (video.data.code === "200") {
          this.$api.saveOrUpdateVideo({notaryId: this.notaryId, url: video.data.data.urf}).then(res => {
            if (res.data.code === "200") {
              this.$notify.success("提交成功！");
              this.onCancel();
              this.$emit('sumitSuccess');
            } else {
              this.$notify.error(res.data.msg);
            }
          }).finally(() => {
            this.loading = false;
          })
        } else {
          this.$notify.error(video.data.msg);
        }
      })
    },

    onCancel() {
      this.dialogVisible = false;
    },

    onStop() {
      this.videoStart = false;
      this.recorder.stopRecording(this.stopRecordingCallback);
    },

    stopRecordingCallback() {
      this.video.src = this.video.srcObject = null;
      this.video.muted = false;
      this.video.volume = 1;
      this.videoData = this.recorder.getBlob();
      this.recorder.camera.stop();
      this.recorder.destroy();
      this.recorder = null;
    },

    startRecording() {
      this.video = document.querySelector('video');
      this.videoStart = true;
      this.captureCamera((camera) => {
        this.video.muted = true;
        this.video.volume = 0;
        this.video.srcObject = camera;
        this.recorder = RecordRTC(camera, { type: "video"});
        this.recorder.startRecording();
        // release camera on stopRecording
        this.recorder.camera = camera;
      });
    },

    stopRecording() {
      this.videoStart = false;
      this.recorder.stopRecording(this.stopRecordingCallback);
    }
  }

};
</script>

<style scoped lang="scss">

</style>
